//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import { Card } from "vue-stripe-elements-plus";
import { showErrorMsg } from "../../utils/error";
import { updateUserInfo } from "../../services/users";
import { createSetupIntent } from "../../apis/payment";
import { updatePaymentMethod } from "../../services/payment";

let elements = null;
let clientSecret = null;
let cardElement = null;

const initStripePayment = async (stripe, onComplete) => {
  // 存储 secret 避免重复调用
  clientSecret = await createSetupIntent();

  elements = stripe.elements({ clientSecret });

  cardElement = elements.create("card", {
    hidePostalCode: true
  });
  cardElement.mount("#card-element");
  cardElement.on("change", event => {
    if (event.complete) {
      onComplete();
    }
  });
};

export default {
  name: "PaymentBillingPage",
  components: { HiCell, HiHeader, HiButton, Card },
  activated: function() {
    initStripePayment(this.$stripe, () => {
      this.complete = true;
    });
  },
  methods: {
    /**
     * 编辑按钮点击事件
     */
    async edit() {
      try {
        this.$loading.show();
        const result = await this.$stripe.confirmCardSetup(clientSecret, {
          payment_method: {
            card: cardElement
          }
        });

        if (result.error) {
          this.$alert.show(result.error.message || "");
        } else {
          await updatePaymentMethod(result.setupIntent.payment_method);
          await updateUserInfo({ withStripe: true });
          this.$router.go(-1);
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    }
  },
  data() {
    return {
      stripe: {
        publishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
        options: {
          hidePostalCode: true
        }
      },
      complete: false
    };
  }
};



// WEBPACK FOOTER //
// ./src/pages/payment/BillingEdit.vue